import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/eduegoo/frontend/app/instructors/InstructorsPage.tsx");
